/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSnoozeConfiguration } from './ApiSnoozeConfiguration';
import {
    ApiSnoozeConfigurationFromJSON,
    ApiSnoozeConfigurationFromJSONTyped,
    ApiSnoozeConfigurationToJSON,
    ApiSnoozeConfigurationToJSONTyped,
} from './ApiSnoozeConfiguration';
import type { ApiPersonType } from './ApiPersonType';
import {
    ApiPersonTypeFromJSON,
    ApiPersonTypeFromJSONTyped,
    ApiPersonTypeToJSON,
    ApiPersonTypeToJSONTyped,
} from './ApiPersonType';
import type { ApiPersonCategory } from './ApiPersonCategory';
import {
    ApiPersonCategoryFromJSON,
    ApiPersonCategoryFromJSONTyped,
    ApiPersonCategoryToJSON,
    ApiPersonCategoryToJSONTyped,
} from './ApiPersonCategory';

/**
 * a Person
 * @export
 * @interface ApiPerson
 */
export interface ApiPerson {
    /**
     * External unique person ID
     * @type {string}
     * @memberof ApiPerson
     */
    id: string;
    /**
     * 
     * @type {ApiPersonType}
     * @memberof ApiPerson
     */
    type?: ApiPersonType;
    /**
     * Person attributes key value pair
     * @type {{ [key: string]: string; }}
     * @memberof ApiPerson
     */
    attributes?: { [key: string]: string; };
    /**
     * Person current status
     * @type {ApiPersonStatusEnum}
     * @memberof ApiPerson
     */
    status?: ApiPersonStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof ApiPerson
     */
    createdTime?: Date;
    /**
     * 
     * @type {ApiSnoozeConfiguration}
     * @memberof ApiPerson
     */
    snoozeConfiguration?: ApiSnoozeConfiguration;
    /**
     * Configurations for scenario based snooze configurations
     * @type {Array<ApiSnoozeConfiguration>}
     * @memberof ApiPerson
     */
    scenarioSnoozeConfigurations?: Array<ApiSnoozeConfiguration>;
    /**
     * 
     * @type {ApiPersonCategory}
     * @memberof ApiPerson
     */
    category?: ApiPersonCategory;
}

/**
* @export
* @enum {string}
*/
export enum ApiPersonStatusEnum {
    NEW = 'NEW',
    REVIEWED = 'REVIEWED',
    MONITORING = 'MONITORING',
    SUSPENDED = 'SUSPENDED',
    TERMINATED = 'TERMINATED',
    TERMINATED_AND_REPORTED = 'TERMINATED_AND_REPORTED'
}


/**
 * Check if a given object implements the ApiPerson interface.
 */
export function instanceOfApiPerson(value: object): value is ApiPerson {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ApiPersonFromJSON(json: any): ApiPerson {
    return ApiPersonFromJSONTyped(json, false);
}

export function ApiPersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiPerson {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'] == null ? undefined : ApiPersonTypeFromJSON(json['type']),
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
        'status': json['status'] == null ? undefined : json['status'],
        'createdTime': json['createdTime'] == null ? undefined : (new Date(json['createdTime'])),
        'snoozeConfiguration': json['snoozeConfiguration'] == null ? undefined : ApiSnoozeConfigurationFromJSON(json['snoozeConfiguration']),
        'scenarioSnoozeConfigurations': json['scenarioSnoozeConfigurations'] == null ? undefined : ((json['scenarioSnoozeConfigurations'] as Array<any>).map(ApiSnoozeConfigurationFromJSON)),
        'category': json['category'] == null ? undefined : ApiPersonCategoryFromJSON(json['category']),
    };
}

export function ApiPersonToJSON(json: any): ApiPerson {
    return ApiPersonToJSONTyped(json, false);
}

export function ApiPersonToJSONTyped(value?: ApiPerson | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ApiPersonTypeToJSON(value['type']),
        'attributes': value['attributes'],
        'status': value['status'],
        'createdTime': value['createdTime'] == null ? value['createdTime'] : value['createdTime'].toISOString(),
        'snoozeConfiguration': ApiSnoozeConfigurationToJSON(value['snoozeConfiguration']),
        'scenarioSnoozeConfigurations': value['scenarioSnoozeConfigurations'] == null ? undefined : ((value['scenarioSnoozeConfigurations'] as Array<any>).map(ApiSnoozeConfigurationToJSON)),
        'category': ApiPersonCategoryToJSON(value['category']),
    };
}

